<template>
    <ul class="navbar-nav ml-auto">

        <!--<li class="nav-item d-md-down-none">
            <a href="#">
                <i class="fa fa-bell"></i>
                <span v-if="notifications && notifications.alerts > 0" class="badge badge-pill badge-danger">{{notifications.alerts}}</span>
            </a>
        </li>

        <li class="nav-item d-md-down-none">
            <a href="#">
                <i class="fa fa-envelope-open"></i>
                <span v-if="notifications && notifications.messages > 0" class="badge badge-pill badge-danger">{{notifications.messages}}</span>
            </a>
        </li>-->
        <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="avatar">{{userLetter}}</span>
                <span class="small ml-1 d-md-down-none">{{user.profile.name}}</span>
            </a>

            <div class="dropdown-menu dropdown-menu-right">
                <div class="dropdown-header">Account</div>

                <a href="/user/profile" class="dropdown-item">
                    <i class="fa fa-user"></i> Profile
                </a>
                <div v-if="user && user.profile && user.profile.role && (user.profile.role.includes('PortalAdministrator') || user.profile.role.includes('Developer') || user.profile.role.includes('NowMicro_Sales') ||  user.profile.role.includes('NowMicro_Support'))" class="nav-item nav-dropdown">
                    <button @click="isPopupVisible = !isPopupVisible" class="dropdown-item">
                        <i class="fas fa-building"></i> Change Organization
                    </button>
                    <dx-popup :visible.sync="isPopupVisible"
                              :drag-enabled="false"
                              :close-on-outside-click="true"
                              :show-title="true"
                              @content-ready="ready"
                              :width="750"
                              :height="543"
                              class="popup"
                              title="Choose Organization">
                        <div>
                            <transition name="fade">
                                <dx-list v-if="dataSource"
                                         :data-source="dataSource"
                                         :height="400"
                                         :bounceEnabled="true"
                                         :search-enabled="true"
                                         :search-mode="searchMode"
                                         :scrollingEnabled="true"
                                         :visible="true"
                                         @item-click="itemClick"
                                         displayExpr="name"
                                         search-expr="name">
                                    <div slot="dataSource"
                                         slot-scope="{ dataSource }">
                                        <div v-if="dataSource">{{dataSource.name}}</div>
                                    </div>
                                </dx-list>
                            </transition>
                            <transition name="fade">
                                <dx-button v-if="dataSource"
                                           :disabled="disabled"
                                           icon="refresh"
                                           hint="refresh"
                                           @click="clearOrganization">
                                </dx-button>
                            </transition>

                        </div>
                    </dx-popup>
                </div>

                <!--<div class="dropdown-header">Settings</div>-->
                <!--<a href="#" class="dropdown-item">
                    <i class="fa fa-bell"></i> Notifications
                </a>

                <a href="#" class="dropdown-item">
                    <i class="fa fa-wrench"></i> Settings
                </a>-->

                <button v-on:click="logout" id="logout" class="dropdown-item">
                    <i class="fa fa-lock"></i> Logout
                </button>
            </div>
        </li>
    </ul>
</template>
<script>
    import DxList from 'devextreme-vue/list';
    import { DxPopup, } from 'devextreme-vue/popup';
    import ApiService from '@/services/ApiService.js';
    import { DxButton } from 'devextreme-vue';
    import Moment from 'moment'

    let apiService = new ApiService();

    let moment = new Moment();

    let currentDate = new Date();
    currentDate = moment.utc(currentDate).format();

    let endOfDay = moment.utc().endOf('day').format();

    //import axios from 'axios'
    export default {
        name: 'UserService',
        props: {
            user: Object,
            logout: Function
        },
        data() {
            return {
                notifications: null,
                errors: null,
                isPopupVisible: false,
                dataSource: null,
                disabled: null,
                searchMode: 'contains',
                selectedOrg: null,
                organizations: {
                    expireDate: endOfDay,
                    data: null
                }
            }
        },
        components: {
            DxPopup,
            DxList,
            DxButton
        },
        methods: {
            ready() {
                let bool = JSON.parse(localStorage.getItem('org'))
                if (bool) {
                    this.disabled = false;
                } else {
                    this.disabled = true;
                }
                if (localStorage.getItem("organzations") !== null) {
                    if (this.EndOfDayExpiration > currentDate && this.organizations.data !== null) {
                        this.dataSource = JSON.parse(localStorage.getItem("organizations"));
                    } else {
                        apiService.get(process.env.VUE_APP_DICE_URI + "/dice/dashboard/getAllOrgs").then(
                            success => {
                                this.dataSource = success
                                localStorage.setItem("organizations", JSON.stringify(this.dataSource));
                            }, err => {
                                console.log(err)
                            })
                    }
                } else {
                    apiService.get(process.env.VUE_APP_DICE_URI + "/dice/dashboard/getAllOrgs").then(
                        success => {
                            this.dataSource = success
                            localStorage.setItem("organizations", JSON.stringify(this.dataSource));
                        }, err => {
                            console.log(err)
                        })
                }
            },
            itemClick(e) {
                this.selectedOrg = e.itemData.name
                if (this.user && this.user.profile && this.user.profile.role && (this.user.profile.role.includes('PortalAdministrator') || this.user.profile.role.includes('Developer') || this.user.profile.role.includes('NowMicro_Sales') || this.user.profile.role.includes('NowMicro_Support'))) {
                    localStorage.setItem('org', JSON.stringify(`${this.selectedOrg}`))
                    localStorage.removeItem("openOrders");
                    localStorage.removeItem("completedOrders");
                    localStorage.removeItem("createdDevices")
                    localStorage.removeItem("warranties")
                    localStorage.removeItem("devices")
                    location.reload();
                }
            },
            clearOrganization() {
                localStorage.removeItem("org")
                localStorage.removeItem("openOrders")
                localStorage.removeItem("completedOrders");
                localStorage.removeItem("createdDevices")
                localStorage.removeItem("warranties")
                localStorage.removeItem("devices")
                location.reload();
            },

        },
        computed: {
            userLetter: function () {
                return this.user.profile.name[0]
            },

        },
        created() {
        }
    }
</script>

<style>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 1.5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>